import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import ScaleFadeTransition from "shared/components/ScaleFadeTransition";
import ClickWatcher from "shared/components/ClickWatcher";
import OkRadio from "shared/components/oknf/OkRadio";
import _str from "shared/util/_str";

import {
	SEND_TRIGGER_TYPE,
} from "apps/messenger/util/consts";

import "apps/messenger/components/MainWindow/SendTriggerMenu.scss";

const SEND_TRIGGER_OPTIONS = [
	{ label: _str("Press enter to send"), value: SEND_TRIGGER_TYPE.EnterToSend },
	{ label: _str("Click to send"), value: SEND_TRIGGER_TYPE.ClickToSend },
];

const SendTriggerMenu = ({
	preferredSendTrigger,
	onChangePreferredSendTrigger,
}) => {
	// Menu toggling.
	const [sendTriggerMenuVisible, setSendTriggerMenuVisible] = useState(false);
	const _onToggleSendMenu = useCallback(
		() => setSendTriggerMenuVisible(!sendTriggerMenuVisible), [sendTriggerMenuVisible],
	);
	const _onChangeSendTrigger = useCallback(
		(event) => {
			onChangePreferredSendTrigger(parseInt(event.target.value, 10));
			setSendTriggerMenuVisible(false);
		},
		[onChangePreferredSendTrigger],
	);

	return (
		<ClickWatcher
			className="messenger-send-trigger-menu-container"
			onOutsideClick={_onToggleSendMenu}
			active={sendTriggerMenuVisible}
		>
			<button
				className={classnames("messenger-send-trigger-menu-toggle", {
					"messenger-send-trigger-menu-toggle--active": sendTriggerMenuVisible,
				})}
				onClick={_onToggleSendMenu}
			>
				<span className="icon i-ellipsis-v" />
			</button>

			<ScaleFadeTransition speed={ScaleFadeTransition.speeds.Half}>
				{sendTriggerMenuVisible && (
					<div className="messenger-send-trigger-menu oknf oknf--gray">
						{SEND_TRIGGER_OPTIONS.map((options) => (
							<div className="messenger-send-trigger-menu-item" key={options.value}>
								<OkRadio
									value={options.value}
									label={options.label}
									checked={preferredSendTrigger === options.value}
									onChange={_onChangeSendTrigger}
								/>
							</div>
						))}
					</div>
				)}
			</ScaleFadeTransition>
		</ClickWatcher>
	);
};

SendTriggerMenu.propTypes = {
	preferredSendTrigger: PropTypes.oneOf(Object.values(SEND_TRIGGER_TYPE)).isRequired,
	onChangePreferredSendTrigger: PropTypes.func.isRequired,
};

export default SendTriggerMenu;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/SendTriggerMenu.jsx